import { render, staticRenderFns } from "./index.vue?vue&type=template&id=64f5ef2f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f5ef2f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64f5ef2f')) {
      api.createRecord('64f5ef2f', component.options)
    } else {
      api.reload('64f5ef2f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=64f5ef2f&scoped=true", function () {
      api.rerender('64f5ef2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hdybzbgl/index.vue"
export default component.exports